const erp = erp || {};
//java服务端接口访问头

const web_root = 'https://www.b100y.com/';  /*------正式------*/

const by_root = 'https://www.b100y.com/';  /*H5链接正式*/

const by_baseApi = 'https://api.b100y.com/';  /*百驿正式的服务端接口*/
  
erp.wywy_root = 'https://www.b100y.com/'


//im交流服务端接口
   erp.io = "https://api.b100y.com:8445";		/*------正式------*/
//erp.io = "https://www.wy56.com/test/h5:8444"; /*------测试------*/


erp.web_base = web_root;

erp.wx_pub_appid = "wxc2a6dbf16401b84d";

//otms-api接口
erp.OTMS_API = web_root + "otms-api/"

//园区接口
erp.YUANQU = web_root + "yuanqu-api/"

//园区接口
erp.TRUCK_API = web_root + "truck-api/"


//园区node-api
erp.TRUCK_NODE_API = web_root + "truck-node-api/"



// erp.cmcc_clientid = "300011853327";           //正式
erp.cmcc_clientid = "300011853396"; //测试

erp.bcPath = web_root;

erp.wxShare = web_root + "truck-api/v002/"; //获取jsapi_ticket 分享接口只能用于正式环境

const base = by_baseApi + 'yuanqu-api/';
const bancheBase = web_root + 'truck-api/';

//nodejs服务端接口访问头
const hcy_base = by_baseApi + 'truck-node-api/';

//旧版班车服务端接口访问头
const hm_base = web_root + 'front/';


//登录认证authorization
const base_sessionId = localStorage.getItem("userId");



//其他项目h5跳转访问头

erp.h5_base = by_root + "h5/";

erp.byH5_base = by_root + "h5/";

//地图跳转
erp.h5_base_map = web_root + "h5/parkmall";

erp.weChat_root = web_root + "h5/parkmall/";

erp.pay_center = web_root + "h5/pay-center/";
// erp.pay_center = by_root + "h5/pay-center/";

erp.base64 = hm_base;

//货的接口
erp.base_cargo = web_root + 'api/'

//旧版班车服务端接口：用户接口
erp.forgetPasswd = hm_base + 'f/cust/';
erp.rebuildPasswd = hm_base + 'cust/';


erp.messageURL = base + 'sc/v001/';

erp.messageURL1 = base + 'sc/v002/';

erp.hcy_messageURL = hcy_base + 'v001/shop/';
erp.hcy_messageURL2 = hcy_base + 'v001/bgShop/';
erp.hcy_messageURL3 = hcy_base + 'v001/zx/';

erp.yzmURL = base + 'scm/v001/';

//专车
erp.specialCar = web_root + 'otms-api/';

//快递100访问接口
erp.kuaidi100 = 'https://m.kuaidi100.com/index_all.html';

//移动授权信息
erp.loginWithCMCC = base + 'sc/v001/user/loginWithCMCC';

erp.otmsApi = web_root + 'otms-api/public_method/';


erp.base_sessionId = base_sessionId;

erp.base = base;
erp.bancheBase = bancheBase;

module.exports = erp
